import MyProfileEdit from './MyProfileEdit';

export default MyProfileEdit;
